import React, { Component } from 'react';
import { Accordion, Icon } from 'semantic-ui-react'

import AdInfo from './AdInfo';
import './AdsList.css';

class AdsList extends Component {

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = this.props.index === index ? -1 : index;

    this.props.handleActiveIndex(newIndex);
  }

  render() {
    const activeIndex = this.props.index
    return (
      <div>
        <div className="ad-list">
          <Accordion styled>
            {
              this.props.ads.map((ad, index) => {
                return (
                  <div>
                    <Accordion.Title active={activeIndex === index || this.props.expandAll} index={index} onClick={this.handleClick}>
                      <Icon name="dropdown" />
                      {ad.ad_name}
                    </Accordion.Title>
                    <Accordion.Content active={activeIndex === index || this.props.expandAll}>
                      <AdInfo key={ad.ad_id} ad={ad} />
                    </Accordion.Content>
                  </div>
                )
              })
            }
          </Accordion>
        </div>
      </div>
    );
  }
}

export default AdsList;



// WEBPACK FOOTER //
// ./src/screens/AdComparer/AdsList.js